import { IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { ITagObject } from "../../../../../domain/editableFormat/objects";
import { ITagObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import {
  EditBehaviorTranslator,
  InputMethodBehaviorTranslator,
  TurnedTextStyleTranslator,
} from "./properties";
import { StandardTextDrawableObjectTranslator } from "./base";

export class TagObjectTranslator extends AbstractObjectTranslator<ITagObject, ITagObjectBean> {
  constructor() {
    super(new StandardTextDrawableObjectTranslator());
  }

  protected shouldRecordName(source: ITagObjectBean): boolean {
    return true;
  }

  protected readName(source: ITagObjectBean): IObjectNameIdentifier {
    return {
      name: source["@title"],
    };
  }

  overwriteObject(source: ITagObject, bean: ITagObjectBean, formatId: number): void {
    source.name = bean["@title"];                                     // tagの名称はtitle.
    source.editBehavior = this.editBehavior.from(bean);
    source.inputMethodBehavior = this.inputMethodBehavior.from(bean);
    source.turnedTextStyle = this.turnedTextStyle.from(bean);
  }

  overwriteBean(source: ITagObjectBean, object: ITagObject): void {
    source["@name"] = "";                                             // tagの名称はtitle.
    source["@title"] = object.name;                                   // tagの名称はtitle.
    source["@vanish"] = this.editBehavior.to(object).vanish;
    source["@type"] = "2";
    source["@input-code"] = this.inputMethodBehavior.to(object).inputCode;
    source["@asterisk"] = this.turnedTextStyle.to(object).asterisk;
  }

  private readonly editBehavior = new EditBehaviorTranslator();
  private readonly inputMethodBehavior = new InputMethodBehaviorTranslator();
  private readonly turnedTextStyle = new TurnedTextStyleTranslator();
}
